import { useDispatch, useSelector } from "react-redux";
import { AntdInput, AntdPassInput, AntdSubmit } from "../../../components";
import styles from "./ChangePassword.module.css";
import { useNavigate } from "react-router-dom";
import { Form, Typography } from "antd";
import AlertAction from "../../../store/Actions/AlertActions";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import AuthMiddleware from "../../../store/Middlewares/AuthMiddleware";
const ChangePassword = () => {
  const { t, i18n } = useTranslation()
  const dispatch =  useDispatch();
  const navigate = useNavigate();
  const { Text } = Typography;
  // const user = useSelector(state => state.AuthReducer.user);
  //   console.log('userrrrr', user);

    useEffect(() => {
    getLanguage()
  }, [])
  const getLanguage = async () => {
    try {
      const language = await localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };
  const onFinish = (values) => {
    console.log('Success values:', values);
    if (!values.old_password || !values.new_password || !values.confirm_password) {
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'All fields required' }))
    }else if (values.New_Password != values.Confirm_Password) {
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Password not match' }))
      } else{
        dispatch(AuthMiddleware.updatePassword(values))
        .then((data) => {
          dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
          navigate(-1)
        })
        .catch((error) => {
          console.warn(error);
        });
      }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    // dispatch(AlertAction.ShowAlert({ type: "warning", message: errorInfo.message }))
  };
  const [form] = Form.useForm();
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>{t("Change Password")}</h1>
      </div>
      <h2>{t("Change Password")}</h2>
      {/* <div > */}
      <Form
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className={styles.content}
        style={{ width: '100%' }}
      >

        <div className={styles.input}>
          <AntdPassInput
            placeholder={"********"}
            name={"old_password"}
            label={t("OldPassword")}
            rules={[
              {
                require: true,
                type: "text",
                message: "Please enter your Old password",
              },
              // {
              //   pattern:
              //     /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/,
              //   message: `Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!`,
              // },
            ]}
          />
        </div>
        <div className={styles.input}>
          <AntdPassInput
            placeholder={"********"}
            name={"new_password"}
            label={t("NewPassword")}
            rules={[
              {
                require: true,
                type: "text",
                message: "Please enter your New password",
              },
              {
                pattern:
                  /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/,
                message: `Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!`,
              },
            ]}
          />
        </div>
        <div className={styles.input}>
          <AntdPassInput
            placeholder={"********"}
            name={"confirm_password"}
            label={t("ConfirmPassword")}
            rules={[
              {
                require: true,
                type: "text",
                message: "Please enter your Confirm password",
              },
              {
                pattern:
                  /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/,
                message: `Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!`,
              },
            ]}
          />
        </div>
        <div className={styles.button}>
          <AntdSubmit
            text={t("Change Password")}
            buttonStyle={{ margin: "15px 0px", height: "60px" }}
          />
        </div>
        </Form >
      {/* </div> */}
    </div>
  );
};
export default ChangePassword;
